import { render } from "./ShowcaseHome.vue?vue&type=template&id=d5da1f8a&scoped=true&ts=true"
import script from "./ShowcaseHome.vue?vue&type=script&lang=ts"
export * from "./ShowcaseHome.vue?vue&type=script&lang=ts"

import "./ShowcaseHome.vue?vue&type=style&index=0&id=d5da1f8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5da1f8a"]])

export default __exports__